// LOCAL: shared markup for the temporary store-section placeholder pages.
// Each stub renders a `<Card>` with a one-line summary and then a few
// `<Section>`s describing what Retool does today (form values, reads,
// mutations). Delete this file once no placeholder needs it.
import { type ReactNode } from 'react';

export function Section({
  heading,
  children,
}: {
  heading: string;
  children: ReactNode;
}) {
  return (
    <section className="space-y-2">
      <h3 className="text-xs font-semibold tracking-wider text-neutral-500 uppercase">
        {heading}
      </h3>
      <div className="space-y-1 text-sm text-neutral-700">{children}</div>
    </section>
  );
}

export function Mono({ children }: { children: ReactNode }) {
  return (
    <code className="rounded bg-neutral-100 px-1 py-0.5 font-mono text-xs text-neutral-900">
      {children}
    </code>
  );
}
